import type * as React from "react";
import { cn } from "../../lib/utils.ts";

export interface MobileShellProps {
  header?: React.ReactNode;
  /** Bottom navigation slot — typically a <BottomNav />. */
  nav?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  /** Render the ambient glow + grain atmosphere behind content (default on). */
  atmosphere?: boolean;
}

/**
 * Mobile-first app frame: warm ambient atmosphere, optional sticky header,
 * scrollable content, fixed bottom nav. Centered, max-width phone column.
 */
export function MobileShell({
  header,
  nav,
  children,
  className,
  atmosphere = true,
}: MobileShellProps) {
  return (
    <div className="relative mx-auto flex min-h-dvh w-full max-w-md flex-col overflow-hidden">
      {atmosphere ? (
        <>
          <div className="jod-ambient" aria-hidden="true" />
          <div className="jod-grain" aria-hidden="true" />
        </>
      ) : null}

      {header ? (
        <div className="glass sticky top-0 z-30 px-4 pt-[calc(0.75rem+env(safe-area-inset-top))] pb-3">
          {header}
        </div>
      ) : null}

      <main
        className={cn("relative z-10 flex-1 px-[18px] py-4", nav ? "pb-28" : "pb-8", className)}
      >
        {children}
      </main>

      {nav}
    </div>
  );
}
